import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import API_URL from '../api';

const EmbedStep = ({ step, courseId, onComplete }) => {
    const [embedUrl, setEmbedUrl] = useState(step.embedUrl || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
    const resolvedRef = useRef(false);

    // Отримати підписаний embed-URL з бекенду (секрет не їде на фронт)
    useEffect(() => {
        let cancelled = false;
        const rawPath = step.embedUrl || step.embedCode || '';
        const pathMatch = rawPath.match(/\/[^?\s]+/) || rawPath.match(/academyocean\.net(\/[^?\s]*)/);
        const path = pathMatch ? pathMatch[0] : rawPath;

        if (!path || path.startsWith('http')) {
            setEmbedUrl(rawPath);
            return;
        }
        setLoading(true);
        axios.get(`${API_URL}/courses/embed-url`, { params: { path } })
            .then(res => {
                if (!cancelled) setEmbedUrl(res.data.embedUrl || rawPath);
            })
            .catch(() => {
                if (!cancelled) setEmbedUrl(rawPath);
            })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [step.embedUrl, step.embedCode]);

    // Слухати postMessage від Academy Ocean (завершення / прогрес)
    useEffect(() => {
        const handler = (event) => {
            let data;
            try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; }
            catch { return; }
            const isAo = event.origin.includes('academyocean') ||
                (data && (data.source === 'academyocean' || data.platform === 'academyocean'));
            if (!isAo) return;
            if (data.event === 'completed' || data.event === 'finish' || data.completed || data.type === 'complete') {
                if (!resolvedRef.current) {
                    resolvedRef.current = true;
                    setDone(true);
                    onComplete && onComplete();
                }
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, [onComplete]);

    if (loading) {
        return <div className="embed-step-loading">🔄 Завантаження вбудованого контенту…</div>;
    }
    if (error) {
        return <div className="embed-step-error">{error}</div>;
    }
    if (!embedUrl) {
        return (
            <div className="embed-step-empty">
                <p>Не вказано посилання на вбудований контент (embedUrl / embedCode).</p>
            </div>
        );
    }

    return (
        <div className={`embed-step-container ${fullscreen ? 'embed-fullscreen' : ''}`}>
            <div className="embed-step-toolbar">
                {done && <span className="embed-completed-badge">✅ Пройдено</span>}
                <button
                    className="embed-fs-btn"
                    onClick={() => setFullscreen(f => !f)}
                    title={fullscreen ? 'Вийти з повноекранного' : 'На весь екран'}
                >
                    {fullscreen ? '🗗' : '⛶'}
                </button>
            </div>
            <div className="embed-frame-wrapper">
                {loading && (
                    <div className="embed-loading-overlay">
                        <div className="loading-spinner" />
                        <span>Завантаження контенту Academy Ocean…</span>
                    </div>
                )}
                <iframe
                    className="embed-step-iframe"
                    src={embedUrl}
                    title={step.title || 'Academy Ocean'}
                    allow="fullscreen; microphone; camera"
                    allowFullScreen
                    onLoad={() => setLoading(false)}
                    onError={() => {
                        setLoading(false);
                        setError('Не вдалося завантажити вбудований контент.');
                    }}
                />
            </div>
            {!done && (
                <div className="embed-manual-complete">
                    <button
                        className="btn-complete-lesson"
                        onClick={() => {
                            if (!resolvedRef.current) {
                                resolvedRef.current = true;
                                setDone(true);
                                onComplete && onComplete();
                            }
                        }}
                    >
                        📖 Позначити як вивчено
                    </button>
                </div>
            )}
        </div>
    );
};

export default EmbedStep;
